<template>
  <!-- Sars go here -->
  <div
    class="stars"
    :class="{ small }"
  >
    <IconsReviewStar
      v-for="i in range(1, 6)"
      :key="i"
      :left="left(i)"
      :right="right(i)"
    />
  </div>
</template>

<script setup>
import { range } from "lodash-es";

const props = defineProps({
  rating: {
    type: [Number, String],
    required: true,
  },
  small: {
    type: Boolean,
    default: false,
  },
});

const left = (i) => {
  return i * 2 - 1 <= props.rating * 2;
};

const right = (i) => {
  return i * 2 <= props.rating * 2;
};
</script>

<style scoped lang="scss">
.stars {
  display: flex;
  flex-direction: row;
  gap: 3.75px;
  width: fit-content;

  svg {
    width: 24px;
    height: 24px;
  }
}

.small {
  gap: 2.25px;

  svg {
    height: 10px;
    width: 10px;
  }
}
</style>
